import {
  FETCHING_COGNITO_USER_PROFILE,
  FETCHING_COGNITO_USER_PROFILE_SUCCEEDED,
  FETCHING_COGNITO_USER_PROFILE_FAILED,
  FETCHING_COGNITO_ACCESS_TOKEN,
  FETCHING_COGNITO_ACCESS_TOKEN_SUCCEEDED,
  FETCHING_COGNITO_ACCESS_TOKEN_FAILED,
  CREATING_USER_REQUEST,
  CREATING_USER_REQUEST_SUCCEEDED,
  CREATING_USER_REQUEST_FAILED,
  FETCHING_USER,
  FETCHING_USER_SUCCEEDED,
  FETCHING_USER_FAILED,
  FETCHING_USERS,
  FETCHING_USERS_SUCCEEDED,
  FETCHING_USERS_FAILED,
  UPDATING_USER_REQUEST,
  UPDATING_USER_SUCCEEDED,
  UPDATING_USER_PERMISSIONS,
  UPDATING_USER_PERMISSIONS_SUCCEEDED,
  UPDATING_USER_PERMISSIONS_FAILED,
  UPDATING_USER_FAILED,
  ACTIVATING_USER_REQUEST,
  ACTIVATING_USER_SUCCEEDED,
  ACTIVATING_USER_FAILED,
  RESET_PASSWORD,
  RESET_PASSWORD_SUCCEEDED,
  RESET_PASSWORD_FAILED,
  RESET_PASSWORD_REQUEST,
  RESET_PASSWORD_REQUEST_SUCCEEDED,
  RESET_PASSWORD_REQUEST_FAILED,
  RESET_PASSWORD_LINK,
  RESET_PASSWORD_LINK_SUCCEEDED,
  RESET_PASSWORD_LINK_FAILED,
  DELETING_USER_REQUEST,
  DELETING_USER_SUCCEEDED,
  DELETING_USER_FAILED,
  FETCHING_USERS_COUNT,
  FETCHING_USERS_COUNT_SUCCEEDED,
  FETCHING_USERS_COUNT_FAILED,
  FETCHING_ACTIVE_USERS_COUNT,
  FETCHING_ACTIVE_USERS_COUNT_SUCCEEDED,
  FETCHING_ACTIVE_USERS_COUNT_FAILED,
  FETCHING_DEACTIVATED_USERS_COUNT,
  FETCHING_DEACTIVATED_USERS_COUNT_SUCCEEDED,
  FETCHING_DEACTIVATED_USERS_COUNT_FAILED,
  FETCHING_NEW_USERS_COUNT,
  FETCHING_NEW_USERS_COUNT_SUCCEEDED,
  FETCHING_NEW_USERS_COUNT_FAILED,
  FETCHING_DAU_COUNT,
  FETCHING_DAU_COUNT_SUCCEEDED,
  FETCHING_DAU_COUNT_FAILED,
  FETCHING_WAU_COUNT,
  FETCHING_WAU_COUNT_SUCCEEDED,
  FETCHING_WAU_COUNT_FAILED,
  FETCHING_MAU_COUNT,
  FETCHING_MAU_COUNT_SUCCEEDED,
  FETCHING_MAU_COUNT_FAILED,
  FETCHING_ADMIN_APP_USERS,
  FETCHING_ADMIN_APP_USERS_SUCCEEDED,
  FETCHING_ADMIN_APP_USERS_FAILED
} from "constants/actionTypes.jsx";

import axios from "axios";
import buildUrl from "build-url";
import { createAction } from "redux-actions";
import { call, put, takeLatest } from "redux-saga/effects";
import AuthService from "services/auth.service";

const API_URL = process.env.REACT_APP_API_URL;
const API_URL_V2 = process.env.REACT_APP_API_URL_V2;
const OAUTH_TOKEN_URL = `${API_URL_V2}/admin/auth/3.0/oauth/token`;
const REFRESH_TOKEN_URL = `${API_URL_V2}/admin/auth/3.0/oauth/token/refresh`;
const LOGOUT_URL = `${API_URL_V2}/admin/auth/3.0/logout`;

const USERS_BASE_URL = `${API_URL}/api/1.0/users`;
const USER_PROFILE_URL = `${API_URL_V2}/admin/auth/3.0/me`;

const ADMIN_USERS_BASE_URL = `${API_URL}/api/1.0/admin/users`;

/** fetch oauth access token */
export const fetchOAuthToken = createAction(FETCHING_COGNITO_ACCESS_TOKEN);
const fetchingOAuthTokenSucceeded = createAction(
  FETCHING_COGNITO_ACCESS_TOKEN_SUCCEEDED
);
const fetchingOAuthTokenFailed = createAction(
  FETCHING_COGNITO_ACCESS_TOKEN_FAILED
);

function* fetchOAuthTokenSaga() {
  const fetchOAuthTokenAPI = () => {
    return axios({
      method: "GET",
      url: OAUTH_TOKEN_URL,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchOAuthTokenAPI);
    yield put(fetchingOAuthTokenSucceeded(response));
  } catch (error) {
    yield put(fetchingOAuthTokenFailed(error));
  }
}

/** cognito: refresh oauth access token */
export function refreshOAuthToken(refresh_token) {
  const data = {
    refresh_token,
  };

  return axios({
    method: "GET",
    url: REFRESH_TOKEN_URL,
    params: data,
  });
}

/** cognito: fetch user profile */
export const fetchUserProfile = createAction(FETCHING_COGNITO_USER_PROFILE);
const fetchingUserProfileSucceeded = createAction(
  FETCHING_COGNITO_USER_PROFILE_SUCCEEDED
);
const fetchingUserProfileFailed = createAction(
  FETCHING_COGNITO_USER_PROFILE_FAILED
);

function* fetchUserProfileSaga(action) {
  const fetchUserProfileAPI = () => {
    return axios({
      method: "GET",
      url: USER_PROFILE_URL,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchUserProfileAPI);
    yield put(fetchingUserProfileSucceeded(response));
  } catch (error) {
    yield put(fetchingUserProfileFailed(error));
  }
}

/** cognito: logout user 
export const logoutUser = createAction(LOGOUT_COGNITO_USER);

function* logoutUserSaga() {
  const logoutUserAPI = () => {
    return axios({
      method: "GET",
      url: LOGOUT_URL,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(logoutUserAPI);
    console.log("logout user successfully: ", response);
  } catch (error) {
    console.log("failed to logout cognito: ", error);
  }
}
*/

/**
 * create a new user
 */
export const createUser = createAction(CREATING_USER_REQUEST);
const creatingUsersSucceeded = createAction(CREATING_USER_REQUEST_SUCCEEDED);
const creatingUserFailed = createAction(CREATING_USER_REQUEST_FAILED);

function* createUserSaga(action) {
  let { accountId, user } = action.payload;

  const createUserAPI = () => {
    return axios({
      method: "POST",
      url: USERS_BASE_URL,
      data: user,
      params: { accountId },
    }).then((response) => response.data);
  };

  try {
    const response = yield call(createUserAPI);
    yield put(creatingUsersSucceeded(response));
  } catch (error) {
    yield put(creatingUserFailed(error));
  }
}

/**
 * fetching user with id
 */
export const fetchUser = createAction(FETCHING_USER);
const fetchingUserSucceeded = createAction(FETCHING_USER_SUCCEEDED);
const fetchingUserFailed = createAction(FETCHING_USER_FAILED);

function* fetchUserSaga(action) {
  let { id } = action.payload;
  
  let url = buildUrl(USERS_BASE_URL, { path: `${id}` });
  const fetchUserAPI = () => {
    return axios({
      method: "GET",
      url: url,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchUserAPI);
    yield put(fetchingUserSucceeded(response));
  } catch (error) {
    yield put(fetchingUserFailed(error));
  }
}

/**
 * fetching users - filters
 */

export const fetchUsers = createAction(FETCHING_USERS);
const fetchingUsersSucceeded = createAction(FETCHING_USERS_SUCCEEDED);
const fetchingUsersFailed = createAction(FETCHING_USERS_FAILED);

function* fetchUsersSaga(action) {
  let { page, limit, filters } = action.payload;

  let url = buildUrl(USERS_BASE_URL, { path: "/search" });
  const fetchUsersAPI = () => {
    return axios({
      method: "POST",
      url: url,
      params: { page, limit },
      data: filters,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchUsersAPI);
    yield put(fetchingUsersSucceeded(response));
  } catch (error) {
    yield put(fetchingUsersFailed(error));
  }
}

export const fetchUsersCount = createAction(FETCHING_USERS_COUNT);
const fetchingUsersCountSucceeded = createAction(
  FETCHING_USERS_COUNT_SUCCEEDED
);
const fetchingUsersCountFailed = createAction(FETCHING_USERS_COUNT_FAILED);

function* fetchUsersCountSaga(action) {
  let { account } = action.payload;
  let url = buildUrl(USERS_BASE_URL, { path: "/count" });
  const fetchUsersCountAPI = () => {
    return axios({
      method: "POST",
      url: url,
      data: { account: account },
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchUsersCountAPI);
    yield put(fetchingUsersCountSucceeded(response));
  } catch (error) {
    yield put(fetchingUsersCountFailed(error));
  }
}

export const fetchActiveUsersCount = createAction(FETCHING_ACTIVE_USERS_COUNT);
const fetchingActiveUsersCountSucceeded = createAction(
  FETCHING_ACTIVE_USERS_COUNT_SUCCEEDED
);
const fetchingActiveUsersCountFailed = createAction(
  FETCHING_ACTIVE_USERS_COUNT_FAILED
);

function* fetchActiveUsersCountSaga(action) {
  let { account, type } = action.payload;

  let url = buildUrl(USERS_BASE_URL, { path: "/count" });
  const fetchActiveUsersCountAPI = () => {
    return axios({
      method: "POST",
      url: url,
      data: { account, type },
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchActiveUsersCountAPI);
    yield put(fetchingActiveUsersCountSucceeded(response));
  } catch (error) {
    yield put(fetchingActiveUsersCountFailed(error));
  }
}

export const fetchDeactivatedUsersCount = createAction(
  FETCHING_DEACTIVATED_USERS_COUNT
);
const fetchingDeactivatedUsersCountSucceeded = createAction(
  FETCHING_DEACTIVATED_USERS_COUNT_SUCCEEDED
);
const fetchingDeactivatedUsersCountFailed = createAction(
  FETCHING_DEACTIVATED_USERS_COUNT_FAILED
);

function* fetchDeactivatedUsersCountSaga(action) {
  let { account, type } = action.payload;

  let url = buildUrl(USERS_BASE_URL, { path: "/count" });
  const fetchDeactivatedUsersCountAPI = () => {
    return axios({
      method: "POST",
      url: url,
      data: { account, type },
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchDeactivatedUsersCountAPI);
    yield put(fetchingDeactivatedUsersCountSucceeded(response));
  } catch (error) {
    yield put(fetchingDeactivatedUsersCountFailed(error));
  }
}

export const fetchDAUCount = createAction(FETCHING_DAU_COUNT);
const fetchingDAUCountSucceeded = createAction(FETCHING_DAU_COUNT_SUCCEEDED);
const fetchingDAUCountFailed = createAction(FETCHING_DAU_COUNT_FAILED);

function* fetchDAUCountSaga(action) {
  let { account, dateFrom, dateTo } = action.payload;

  let url = buildUrl(USERS_BASE_URL, { path: "/count/active" });
  const fetchDAUCountAPI = () => {
    return axios({
      method: "POST",
      url: url,
      data: { account, dateFrom, dateTo },
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchDAUCountAPI);
    yield put(fetchingDAUCountSucceeded(response));
  } catch (error) {
    yield put(fetchingDAUCountFailed(error));
  }
}

export const fetchWAUCount = createAction(FETCHING_WAU_COUNT);
const fetchingWAUCountSucceeded = createAction(FETCHING_WAU_COUNT_SUCCEEDED);
const fetchingWAUCountFailed = createAction(FETCHING_WAU_COUNT_FAILED);

function* fetchWAUCountSaga(action) {
  let { account, dateFrom, dateTo } = action.payload;
  let url = buildUrl(USERS_BASE_URL, { path: "/count/active" });
  const fetchWAUCountAPI = () => {
    return axios({
      method: "POST",
      url: url,
      data: { account, dateFrom, dateTo },
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchWAUCountAPI);
    yield put(fetchingWAUCountSucceeded(response));
  } catch (error) {
    yield put(fetchingWAUCountFailed(error));
  }
}

export const fetchMAUCount = createAction(FETCHING_MAU_COUNT);
const fetchingMAUCountSucceeded = createAction(FETCHING_MAU_COUNT_SUCCEEDED);
const fetchingMonthlyActiveUsersFailed = createAction(
  FETCHING_MAU_COUNT_FAILED
);

function* fetchMAUCountSaga(action) {
  let { account, dateFrom, dateTo } = action.payload;

  let url = buildUrl(USERS_BASE_URL, { path: "/count/active" });
  const fetchMAUCountAPI = () => {
    return axios({
      method: "POST",
      url: url,
      data: { account, dateFrom, dateTo },
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchMAUCountAPI);
    yield put(fetchingMAUCountSucceeded(response));
  } catch (error) {
    yield put(fetchingMonthlyActiveUsersFailed(error));
  }
}

export const fetchNewUsers = createAction(FETCHING_NEW_USERS_COUNT);
const fetchingNewUsersSucceeded = createAction(
  FETCHING_NEW_USERS_COUNT_SUCCEEDED
);
const fetchingNewUsersFailed = createAction(FETCHING_NEW_USERS_COUNT_FAILED);

function* fetchNewUsersSaga(action) {
  let { filters } = action.payload;

  let url = buildUrl(USERS_BASE_URL, { path: "/count" });
  const fetchNewUsersAPI = () => {
    return axios({
      method: "POST",
      url: url,
      data: { ...filters },
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchNewUsersAPI);
    yield put(fetchingNewUsersSucceeded(response));
  } catch (error) {
    yield put(fetchingNewUsersFailed(error));
  }
}

/**
 * update user
 */
export const updateUser = createAction(UPDATING_USER_REQUEST);
const updatingUserSucceeded = createAction(UPDATING_USER_SUCCEEDED);
const updatingUserFailed = createAction(UPDATING_USER_FAILED);

function* updateUserSaga(action) {
  const { id, user } = action.payload;

  const updateUserAPI = () => {
    let url = buildUrl(USERS_BASE_URL, { path: `${id}` });

    return axios({
      method: "PUT",
      url: url,
      data: user,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(updateUserAPI);
    yield put(updatingUserSucceeded(response));
  } catch (error) {
    yield put(updatingUserFailed(error));
  }
}

export const updateUserPermissions = createAction(UPDATING_USER_PERMISSIONS);
const updatingUserPermissionsSucceeded = createAction(
  UPDATING_USER_PERMISSIONS_SUCCEEDED
);
const updatingUserPermissionsFailed = createAction(
  UPDATING_USER_PERMISSIONS_FAILED
);

function* updateUserPermissionsSaga(action) {
  let { id, permissions } = action.payload;
  let url = buildUrl(USERS_BASE_URL, { path: `${id}/update-permissions` });
  const updateUserPermissionsAPI = () => {
    return axios({
      method: "PUT",
      url: url,
      data: permissions,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(updateUserPermissionsAPI);
    yield put(updatingUserPermissionsSucceeded(response));
  } catch (error) {
    yield put(updatingUserPermissionsFailed(error));
  }
}

/**
 * activate or deactivate user
 */

export const activateUser = createAction(ACTIVATING_USER_REQUEST);
const activatingUserSucceeded = createAction(
  ACTIVATING_USER_SUCCEEDED,
  (type, response) => ({
    type,
    response,
  })
);
const activatingUserFailed = createAction(
  ACTIVATING_USER_FAILED,
  (type, response) => ({
    type,
    response,
  })
);

function* activateUserSaga(action) {
  const { id, enabled, type } = action.payload;

  const activateUserAPI = () => {
    let url = buildUrl(USERS_BASE_URL, { path: `${id}/activate` });
    return axios({
      method: "PUT",
      url: url,
      params: { enabled },
    }).then((response) => response.data);
  };

  try {
    const response = yield call(activateUserAPI);
    yield put(activatingUserSucceeded(type, response));
  } catch (error) {
    yield put(activatingUserFailed(type, error));
  }
}

/**
 * reset password
 */
export const resetPassword = createAction(RESET_PASSWORD);
const resetPasswordSucceeded = createAction(RESET_PASSWORD_SUCCEEDED);
const resetPasswordFailed = createAction(RESET_PASSWORD_FAILED);

function* resetPasswordSaga(action) {
  let { id, password } = action.payload;

  const resetPasswordAPI = () => {
    let url = buildUrl(USERS_BASE_URL, { path: `${id}/reset-password` });

    return axios({
      method: "PUT",
      url: url,
      data: { newPassword: password },
    }).then((response) => response.data);
  };

  try {
    const response = yield call(resetPasswordAPI);
    yield put(resetPasswordSucceeded(response));
  } catch (error) {
    yield put(resetPasswordFailed(error));
  }
}

/**
 * reset password request
 */
export const resetPasswordRequest = createAction(RESET_PASSWORD_REQUEST);
const resetPasswordRequestSucceeded = createAction(
  RESET_PASSWORD_REQUEST_SUCCEEDED
);
const resetPasswordRequestFailed = createAction(RESET_PASSWORD_REQUEST_FAILED);

function* resetPasswordRequestSaga(action) {
  let { id } = action.payload;

  const resetPasswordRequestAPI = () => {
    let url = buildUrl(USERS_BASE_URL, {
      path: `${id}/reset-password-request`,
    });

    return axios({
      method: "PUT",
      url: url,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(resetPasswordRequestAPI);
    yield put(resetPasswordRequestSucceeded(response));
  } catch (error) {
    yield put(resetPasswordRequestFailed(error));
  }
}

/**
 * reset password link
 */
export const resetPasswordLink = createAction(RESET_PASSWORD_LINK);
const resetPasswordLinkSucceeded = createAction(RESET_PASSWORD_LINK_SUCCEEDED);
const resetPasswordLinkFailed = createAction(RESET_PASSWORD_LINK_FAILED);

function* resetPasswordLinkSaga(action) {
  let { id } = action.payload;

  const resetPasswordLinkAPI = () => {
    let url = buildUrl(USERS_BASE_URL, { path: `${id}/reset-password-link` });

    return axios({
      method: "GET",
      url: url,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(resetPasswordLinkAPI);
    yield put(resetPasswordLinkSucceeded(response));
  } catch (error) {
    yield put(resetPasswordLinkFailed(error));
  }
}

/**
 * delete user
 */
export const deleteUser = createAction(DELETING_USER_REQUEST);
const deletingUserSucceeded = createAction(DELETING_USER_SUCCEEDED);
const deletingUserFailed = createAction(DELETING_USER_FAILED);

function* deleteUserSaga(action) {
  let { id } = action.payload;

  const deleteUserAPI = () => {
    let url = buildUrl(USERS_BASE_URL, { path: `${id}` });

    return axios({
      method: "DELETE",
      url: url,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(deleteUserAPI);
    yield put(deletingUserSucceeded(response));
  } catch (error) {
    yield put(deletingUserFailed(error));
  }
}

export const fetchAdminAppUsers = createAction(FETCHING_ADMIN_APP_USERS);
const fetchAdminAppUsersSucceeded = createAction(FETCHING_ADMIN_APP_USERS_SUCCEEDED);
const fetchAdminAppUsersFailed = createAction(FETCHING_ADMIN_APP_USERS_FAILED);

function* fetchAdminAppUsersSaga() {
    const fetchAccountAPI = () => {
        return axios({
            method: "GET",
            url: ADMIN_USERS_BASE_URL,
        }).then((response) => response.data);
    };

    try {
        const response = yield call(fetchAccountAPI);
        yield put(fetchAdminAppUsersSucceeded(response));
    } catch (error) {
        yield put(fetchAdminAppUsersFailed(error));
    }
}

export default function* usersSaga() {
  yield takeLatest(FETCHING_COGNITO_ACCESS_TOKEN, fetchOAuthTokenSaga);
  yield takeLatest(FETCHING_COGNITO_USER_PROFILE, fetchUserProfileSaga);
  yield takeLatest(CREATING_USER_REQUEST, createUserSaga);
  yield takeLatest(FETCHING_USER, fetchUserSaga);
  yield takeLatest(FETCHING_USERS, fetchUsersSaga);
  yield takeLatest(UPDATING_USER_REQUEST, updateUserSaga);
  yield takeLatest(UPDATING_USER_PERMISSIONS, updateUserPermissionsSaga)
  yield takeLatest(ACTIVATING_USER_REQUEST, activateUserSaga);
  yield takeLatest(RESET_PASSWORD, resetPasswordSaga);
  yield takeLatest(RESET_PASSWORD_REQUEST, resetPasswordRequestSaga);
  yield takeLatest(RESET_PASSWORD_LINK, resetPasswordLinkSaga);
  yield takeLatest(DELETING_USER_REQUEST, deleteUserSaga);
  yield takeLatest(FETCHING_USERS_COUNT, fetchUsersCountSaga);
  yield takeLatest(FETCHING_ACTIVE_USERS_COUNT, fetchActiveUsersCountSaga);
  yield takeLatest(
    FETCHING_DEACTIVATED_USERS_COUNT,
    fetchDeactivatedUsersCountSaga
  );
  yield takeLatest(FETCHING_DAU_COUNT, fetchDAUCountSaga);
  yield takeLatest(FETCHING_WAU_COUNT, fetchWAUCountSaga);
  yield takeLatest(FETCHING_MAU_COUNT, fetchMAUCountSaga);
  yield takeLatest(FETCHING_NEW_USERS_COUNT, fetchNewUsersSaga);
  yield takeLatest(FETCHING_ADMIN_APP_USERS, fetchAdminAppUsersSaga);
}
